// Styles
import './editorial-img-text.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialImgText = (context) => {
  const editorialImgTextSection = context.closest('.shopify-section');
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.editorial-img-text__container'), (el) => {
    window.dAgency.initEditorialImgText(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.editorial-img-text__container'), (el) => {
      window.dAgency.initEditorialImgText(el);
    });
  });
}
